import { AccordionDetails, AccordionSummary } from "@mui/material";

import { AccordionRoot } from "ui/accordion/accordion.styles";
import { type AccordionProps } from "ui/accordion/accordion.types";
import { useAccordion } from "ui/accordion/use-accordion";
import { Typography } from "ui/typography/typography";

import Icons from "assets";

export const Accordion = ({ title, children, variant = "default", ...rest }: AccordionProps) => {
  const { headerId, panelId } = useAccordion();

  return (
    <AccordionRoot accordionVariant={variant} disableGutters elevation={0} square {...rest}>
      <AccordionSummary id={headerId} aria-controls={panelId} expandIcon={<Icons.ArrowRight />}>
        <Typography variant="inherit" component="span">
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </AccordionRoot>
  );
};
